import Vue from "vue";

Vue.filter("firstChars", (value) =>
   value && value !=''  && value
   .split(" ")
   .map((c) => c[0])
   .join("")
   .toLocaleUpperCase()
);